define('lib/ucFirstEach',[], function() {
    return function(str) {
        str || (str = '');
      return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
})
;
